export const TypeViolationTypes = {
  REFERENCE: 'REFERENCE',
  ARGUMENT: 'ARGUMENT',
  GENERICS: 'GENERICS'
};
export const isReferenceViolation = violation => violation.type === TypeViolationTypes.REFERENCE;
export const isArgumentViolation = violation => violation.type === TypeViolationTypes.ARGUMENT;
export const isGenericTypeViolation = violation => violation.type === TypeViolationTypes.GENERICS;
export const isTypeViolation = violation => isReferenceViolation(violation) || isArgumentViolation(violation) || isGenericTypeViolation(violation);